module.exports = __webpack_public_path__ + "img/no-transaction.d6d8bc4c.svg";